import AdminLayout from "../../../components/admin/layout/AdminLayout";
import SurveyList from "../../../components/common/survey/SurveyList";
import useAuthStore from "../../../store/authStore";
import ManagerSidebar from "../../../components/managerLiveDashboard/sidebar/ManagerSidebar";

function SurveyListPage() {
  const { userType } = useAuthStore();

  return (
    <AdminLayout
      sidebarComponent={userType === 'admin' ? undefined : ManagerSidebar}
    >
      <SurveyList />
    </AdminLayout>
  );
}

export default SurveyListPage;
